import { coerceNumber, getTicks, inferScaleType, scaleTime } from '../../scale';
import Orientation from '../constants/orientation';
import { DIVISIBLE_TICK_AMOUNT } from '../constants/tick_amount';
import createPoint from '../utils/createPoint';
import getTickPosition from '../utils/getTickPosition';
export function useAxisTicks(_ref) {
  let {
    scale,
    numTicks,
    tickValues,
    tickLength,
    orientation,
    hideZero = false
  } = _ref;
  const isLeft = orientation === Orientation.left;
  const isTop = orientation === Orientation.top;
  const horizontal = isTop || orientation === Orientation.bottom;
  const tickPosition = getTickPosition(scale);
  const tickSign = isLeft || isTop ? -1 : 1;
  const range = scale.range();
  const scaleType = inferScaleType(scale);
  const isNumeric = scaleType === 'linear' || scaleType === 'log';
  const tempCalcTicks = Math.round(Math.abs((range[1] || 1) - (range[0] || 0)) / (isLeft ? isNumeric ? DIVISIBLE_TICK_AMOUNT : 18 : DIVISIBLE_TICK_AMOUNT));
  const calculatedNumTicks = (numTicks !== null && numTicks !== void 0 ? numTicks : tempCalcTicks < 2) ? 2 : tempCalcTicks;

  // Check to see if the scale is
  let calculatedScale = scale;

  // Doing a detection here to figure out if we want the ticks to use temporal instead of the
  // ordinal tick detection.
  if ('timeUnit' in scale && typeof scale.timeUnit === 'function' && scale.timeUnit()) {
    const domain = scale.domain();
    if (domain.length > 0) calculatedScale = scaleTime({
      range: scale.range(),
      domain: [scale.domain()[0], scale.domain()[scale.domain().length - 1]]
    });
  }
  const filteredTickValues = (tickValues !== null && tickValues !== void 0 ? tickValues : getTicks(calculatedScale, calculatedNumTicks)).filter(value => !hideZero || value !== 0 && value !== '0').map((value, index) => ({
    value,
    index
  }));
  const ticks = filteredTickValues.reduce((filtered, _ref2) => {
    let {
      value,
      index
    } = _ref2;
    const scaledValue = coerceNumber(tickPosition(value));
    if (tickPosition(value) !== undefined) filtered.push({
      value,
      index,
      from: createPoint({
        x: scaledValue,
        y: 0
      }, horizontal),
      to: createPoint({
        x: scaledValue,
        y: tickLength * tickSign
      }, horizontal)
    });
    return filtered;
  }, []);
  return {
    ticks
  };
}